import React from "react";

import Form from "../components/Form/Form";

function Signup() {
  return (
    <div>
      <Form login={false}></Form>
    </div>
  );
}

export default Signup;
